/**
 * Normalizzazione dei nomi di luogo (docs/04-ingestione.md §2.5).
 *
 * DEVE restare identica a `normalize_place` di sse-ingestion/migrations/build_gazetteer.py
 * (e del matcher Python): i casi di contratto sono in fixtures/normalize.json e sono
 * verificati da entrambi i lati.
 *
 * Passi:
 * 1. NFKD + rimozione dei segni diacritici, minuscolo;
 * 2. apostrofi (' ’ ‘ ` ´ ʼ) → spazio;
 * 3. abbreviazioni di santo: "s.ta" → santa, "s.to" → santo, "s." → sant/santa/santo/san
 *    secondo la parola che segue (vocale → sant, finisce per "a" → santa,
 *    "s"+consonante o "z" → santo, altrimenti san);
 * 4. ogni carattere non alfanumerico (trattini, punti, parentesi...) → spazio;
 * 5. spazi compressi e rimossi ai bordi.
 *
 * Gli errori dell'euristica al punto 3 (es. "S. Foca" → "santa foca") non contano finché
 * entrambe le parti del confronto passano da qui: il gazetteer contiene anche le chiavi
 * normalizzate delle forme abbreviate quando differiscono dal nome.
 */
const APOSTROPHES = /['’‘`´ʼ]/g;
const COMBINING = /\p{M}+/gu;
// "s.ta" / "s. ta" e "s.to" / "s. to" (con o senza punto finale)
const S_TA = /(^|[^a-z0-9])s\.\s*ta(?![a-z0-9])\.?\s*/g;
const S_TO = /(^|[^a-z0-9])s\.\s*to(?![a-z0-9])\.?\s*/g;
// "s." seguito da una parola
const S_DOT = /(^|[^a-z0-9])s\.\s*([a-z0-9]+)/g;
const NON_ALNUM = /[^a-z0-9]+/g;
function expandSaint(next) {
    if (/^[aeiou]/.test(next))
        return 'sant';
    if (next.endsWith('a'))
        return 'santa';
    if (/^(s[^aeiou]|z)/.test(next))
        return 'santo';
    return 'san';
}
export function normalizePlace(text) {
    let s = text.normalize('NFKD').replace(COMBINING, '').toLowerCase();
    s = s.replace(APOSTROPHES, ' ');
    s = s.replace(S_TA, '$1santa ');
    s = s.replace(S_TO, '$1santo ');
    s = s.replace(S_DOT, (_m, pre, next) => `${pre}${expandSaint(next)} ${next}`);
    return s.replace(NON_ALNUM, ' ').trim();
}
/** Slug kebab-case ASCII (stessa logica di `slugify` dello script Python). */
export function slugify(text) {
    return text
        .normalize('NFKD')
        .replace(COMBINING, '')
        .toLowerCase()
        .replace(NON_ALNUM, '-')
        .replace(/^-+|-+$/g, '');
}
//# sourceMappingURL=normalize.js.map